import { Component } from "inferno";
import { MessageProvider, MessageType } from '../../services/messageProvider';
import { LaunchPadItem, SubChannel } from "../../utils/types";
import { Bundle } from '../../services/translationProvider';

type Props = {item: LaunchPadItem, lang: string, startWebChat: Function, onAppOpenClick: Function, appOpening: boolean}

export class ChannelDetail extends Component<Props, any> {

	componentDidMount () {
		const el = document.getElementById('lpChannelSecondRow');
		var s = el.style;
		s.opacity = "0";
		(function fade() {
			var opacity:number = parseFloat(s.opacity) + 0.15;
			if (opacity <= 1) {
				s.opacity = opacity.toString();
				setTimeout(fade,50);
			}
		})();
	};
	
	getDefDescription() {
		switch (this.props.item.type) {
			case SubChannel.webchat: return Bundle.t("VCC_XMSG_LAUNCHPAD_WEBCHAT_DESC");
			case SubChannel.email: return Bundle.t("VCC_XMSG_LAUNCHPAD_EMAIL_DESC");
			case SubChannel.callback: return Bundle.t("VCC_XMSG_LAUNCHPAD_CALLBACK_DESC");
			case SubChannel.phone: return Bundle.t("VCC_XMSG_LAUNCHPAD_PHONE_DESC");
			default: return Bundle.t( this.props.item.qr ? "VCC_XMSG_LAUNCHPAD_CHANNEL_DESC_WITH_QR" : "VCC_XMSG_LAUNCHPAD_CHANNEL_DESC_WITHOUT_QR");
		}
	};

	getChannelText() {
		const item = this.props.item;
		return item.headers && item.headers[this.props.lang] 
			? item.headers[this.props.lang] 
			: this.getDefDescription().replace('{channel}', item.title);
	};

	setAppOpening(toNewTab:boolean) {
		MessageProvider.sendMessage(MessageType.openLink, {url: this.props.item.url, toNewTab: toNewTab});
		this.props.onAppOpenClick();
	};

	getChannelTitle() {
		const item = this.props.item;
		let channelTitle = "";
		switch (item.type) {
			case SubChannel.webchat: channelTitle = Bundle.t("VCC_XTIT_LAUNCHPAD_WEBCHAT"); break;
			case SubChannel.sms: channelTitle = Bundle.t("VCC_XTIT_LAUNCHPAD_SMS"); break;
			case SubChannel.email: channelTitle = Bundle.t("VCC_XTIT_LAUNCHPAD_EMAIL"); break;
			case SubChannel.phone: channelTitle = Bundle.t("VCC_XTIT_LAUNCHPAD_PHONE"); break;
			default: channelTitle = item.title;
		}
		return channelTitle;
	};

	getAppOpeningText() {
		return Bundle.t("VCC_XMSG_LAUNCHPAD_APP_OPENING").replace('{channel}', this.getChannelTitle());
	};

	render() {
		const item = this.props.item;
		const qrCss = {
			"height": "5rem",
			"width": "5rem"
		};
		const channelDetailsCss = {
			"text-align" : this.props.lang === "AR" ? "end" : "start",
			"width": "100%"
		} 
		const secondRowCss = {
			"margin-bottom": "0.5rem"
		}

		const Link = (props:any) => {
			const item = props.item;
			const linkDisplayText = item.linkText ? item.linkText : item.address;
			const openInNewTab = (item.type === SubChannel.custom || item.type === SubChannel.messenger);
			switch (item.type) {
				case SubChannel.webchat: return (
					<a className="p-2 lpLink" href="#" onClick={() => this.props.startWebChat()}>{Bundle.t("VCC_XTIT_LAUNCHPAD_START_WEBCHAT")}</a>
				);
				default: return (
					<a className="p-2 lpLink" href="#" onClick={() => this.setAppOpening(openInNewTab)}>{linkDisplayText}</a>
				);
			}
		};

		return (
			<div id="lpChannelDetails" style={channelDetailsCss}>
				<div className={this.props.lang === "AR" ? "d-flex flex-row-reverse" : "d-flex"}>
					{
						typeof item.icon === "object" && item.icon.base64
						? <div className="lpChannelIcon"><img src={item.icon.base64} /></div>
						: <div className="lpChannelIcon" dangerouslySetInnerHTML={{ __html: item.icon as string }} ></div>
					}
					<div>
						<span style="font-weight: bold;" className="p-2">{this.getChannelTitle()}</span>
						<br/>
						<Link item={item}/>
					</div>
				</div>

				<div className={this.props.lang === "AR" ? "d-flex flex-row-reverse" : "d-flex"} id="lpChannelSecondRow" style={secondRowCss}>
					<div className="d-flex p-2">
							{ item.qr 
								? <div> 
									<img style={qrCss} src={item.qr.base64} />
								</div>
								:null
							}
							<div>								
							{
								this.props.appOpening 
									? <p className={item.qr ? "lpChannelText p-2" : "lpChannelText"}>{this.getAppOpeningText()}</p>
									: <p className={item.qr ? "lpChannelText p-2" : "lpChannelText"}>{this.getChannelText()}</p>
							}
							</div>				

					</div>
				</div>
			</div>
		);
	}
}